import moment from 'moment'
import { formHelp } from './formHelpers'

export const widgetHelpers = {
    checkIfEmpty: (field: { [x: string]: any }, value: any) => {
        if (typeof value !== 'undefined') {
            field.value = value
            if (formHelp.isEmptyField(field)) {
                field.value = null
            }
        }
        return field.value
    },
    findFieldAll: function (id: string, sections: any[]) {
        for (var i = 0; i < 17; i++) {
            let section = sections[i]
            var fieldset = section.instances[0]
            if (fieldset === undefined || fieldset.length === 0) {
                console.error('Warning: No fields are defined. May be a brand new form')
                return []
            }

            var f2: any[] = []
            var f3 = fieldset.fields.filter(function (f: { id: any }) {
                return f.id === id
            })

            if (f3.length > 0) return f3
            if (!f2) {
                console.error('The loaded data does not contain the field ' + id)
            }
        }
    },
    help: function (about: { text: any }) {
        var // topic = about.topic,
            text = about.text

        // return _span(".hide", { onclick: function () { alert("Help about... " + topic); } }, text);
        return <span className="hide">{text}</span>
    },
}
